import React from "react";
import { Plane } from "lucide-react";

// Commercially-safe airline branding: the airline's own site icon (served free by DuckDuckGo),
// with a graceful fallback to a premium generic icon so the UI never looks broken.
export default function AirlineLogo({ logoUrl, name, size = 40, className = "" }) {
  const [failed, setFailed] = React.useState(false);
  const dim = { width: size, height: size };
  if (!logoUrl || failed) {
    return (
      <span data-testid="airline-logo-fallback" style={dim}
        className={`flex items-center justify-center rounded-xl bg-gradient-to-br from-[#0EA5E9]/15 to-[#0F766E]/15 text-[#0369A1] ${className}`}>
        <Plane style={{ width: size * 0.5, height: size * 0.5 }} strokeWidth={2} />
      </span>
    );
  }
  return (
    <span style={dim} className={`flex items-center justify-center overflow-hidden rounded-xl bg-white ring-1 ring-[#EBECE8] ${className}`}>
      <img src={logoUrl} alt={name ? `${name} logo` : "Airline logo"} onError={() => setFailed(true)}
        style={{ width: size * 0.7, height: size * 0.7, objectFit: "contain" }} loading="lazy" />
    </span>
  );
}
